<script>
  import Polygon from '/components/Atoms/Polygon.svelte'
  import IconAudio from '/components/Icons/IconAudio'

  import { onMount } from 'svelte'
  import { canUseWebP } from '/helper'

  export let n = 5
  export let category = ""
  export let title = null
  export let subtitle = null
  export let link = null
  export let bgImage = null
  export let bgImage2x = null
  export let bgImageWebp = null
  export let bgImageWebp2x = null
  export let typeHandle = null
  export let imageContain = false

  let webp = true

  onMount(() => {
    webp = !!bgImageWebp && canUseWebP()
  })


</script>

<Polygon {n} {link} rotate={0.1 * (Math.random() > 0.5 ? 1 : -1)} standardRadius bgColorKey="beige" let:innerHeight={innerHeight}>

  <div 
      class="innerHeight container" 
      style={`--imageUrl: url('${webp ? bgImageWebp : bgImage}'); --imageUrl2x: url('${webp ? bgImageWebp2x : bgImage2x}')`} 
      class:bgImage 
      class:bgImage2x
      class:imageContain 
      class:greenTxt={bgImage && !imageContain}
    >
    <h3 class="top">
      { category }
    </h3>
    <div class="middle" >
      <h3 class="title">
        {title}
      </h3>
      {#if subtitle}
        <h4 class="subtitle">
          {subtitle}
        </h4>
      {/if}
    </div>
    <div class="bottom">
      {#if typeHandle === "audio"}
        <IconAudio />
      {/if}
    </div>
  </div>

</Polygon>

<style lang="scss">
  .container {
    position: absolute;
    display: inline-flex;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
    &.bgImage {
      background-image: var(--imageUrl);
    }

    &.bgImage2x {
      @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) { 
        background-image: var(--imageUrl2x);
      }
    }

    background-size: cover;
    &.imageContain {
      background-size: contain;
      background-position: center;
    } 
    background-repeat: no-repeat;
    background-position: center;
  }

  .top {
    @include typo-serif-small-caps-28-small;
    color: red;
    min-height: 1em;
    margin-top: 18px;
  }

  .middle {
    // color: $color-mint;
    padding: 0 15%;
    hyphens: auto;
    // height: 30%;
    // flex: 1;
    
    /*display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    */

    .greenTxt & {
      color: $color-mint;
    }

    .title {
      @include typo-grotesk-title-30-small;
      .highlight & {
        @include typo-grotesk-title-50-small;
      }
    }

    .subtitle {
      @include typo-grotesk-text-24-small;

    }

  }

  .bottom {
    @include typo-serif-small-caps-28-small;
    min-height: 1em;
    margin-bottom: 18px;
  }

  .icon {
    position: absolute;
    bottom: 15%;
    left: 50%;
    transform: translateX(-50%);
  }

</style>